export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">尋找您的資金方向</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            無論您處於創業初期還是擴張階段，我們都有對應的解決方案
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-6">
              <i className="ri-lightbulb-line text-3xl text-gray-900"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">創業籌備中</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              尚未設立公司，需要創業啟動資金與貸款立輔導。
            </p>
            <a href="/borrowers" className="text-gray-900 font-medium inline-flex items-center hover:text-[#1a5f7a] transition-colors cursor-pointer whitespace-nowrap">
              了解詳情
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          <div className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-6">
              <i className="ri-briefcase-line text-3xl text-gray-900"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">已創業未滿一年</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              剛起步，需要營運週轉資金與初期設備資金。
            </p>
            <a href="/borrowers" className="text-gray-900 font-medium inline-flex items-center hover:text-[#1a5f7a] transition-colors cursor-pointer whitespace-nowrap">
              了解詳情
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          <div className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-6">
              <i className="ri-group-line text-3xl text-gray-900"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">自營商/小頭家</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              經營業登記或僅有稅籍，需要小額簡易專案。
            </p>
            <a href="/borrowers" className="text-gray-900 font-medium inline-flex items-center hover:text-[#1a5f7a] transition-colors cursor-pointer whitespace-nowrap">
              了解詳情
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          <div className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-6">
              <i className="ri-line-chart-line text-3xl text-gray-900"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">中小企業擴張</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              經營一年以上，需要購置設備、轉型或週轉。
            </p>
            <a href="/borrowers" className="text-gray-900 font-medium inline-flex items-center hover:text-[#1a5f7a] transition-colors cursor-pointer whitespace-nowrap">
              了解詳情
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
